import React from "react";
import LinesEllipsis from "react-lines-ellipsis/lib/html";

const ClampText: React.FC<{ text: string; lines: number }> = ({ text, lines }) => {
    return <LinesEllipsis unsafeHTML={text} maxLine={lines} ellipsis="..." trimRight basedOn="letters" />;
};

export default ClampText;
